import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
  response => {
    //console.log(response);
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.message);
      } else if (error.response.status === 401) {
        return Promise.reject('Unauthorised');
      } else {
        return Promise.reject('Error');
      }
    } else if (error.request) {
      console.log(error.request);
      return Promise.reject('Request Timeout');
    } else {
      return Promise.reject(error);
    }
  },
);

export default instance;
